export default "__VITE_ASSET__68xOCfZn__"